<script setup lang="ts">
import {Mail, MapPin, Phone, Send} from "lucide-vue-next";

import "@/assets/styles/contact.css";
</script>

<template>

  <section class="contact">

    <!-- Header -->
    <div class="contact-header">

      <span class="section-badge">
        Kontakt
      </span>

      <h2>
        Lassen Sie uns Ihr Dachprojekt starten
      </h2>

      <p>
        Ob Reparatur, Neueindeckung oder Flachdach – wir beraten Sie persönlich
        und finden die passende Lösung für Ihr Gebäude.
      </p>

    </div>

    <!-- Content -->
    <div class="contact-container">

      <!-- Kontaktinfos -->
      <div class="contact-info">

        <div class="info-card">

          <div class="info-icon">
            <Phone/>
          </div>

          <div>
            <h3>Telefon & Notdienst</h3>
            <p>+49 123 456789 (Mo–Sa erreichbar)</p>
          </div>

        </div>

        <div class="info-card">

          <div class="info-icon">
            <Mail/>
          </div>

          <div>
            <h3>Einsatzgebiet</h3>
            <p>Mannheim & Umgebung</p>
          </div>

        </div>

        <div class="info-card">

          <div class="info-icon">
            <MapPin/>
          </div>

          <div>
            <h3>Notfälle</h3>
            <p>Schnelle Hilfe bei Sturmschäden</p>
          </div>

        </div>

      </div>

      <!-- Formular -->
      <div class="contact-form-wrapper">

        <form class="contact-form">

          <div class="form-grid">

            <div class="form-group">
              <label>Name</label>
              <input type="text" placeholder="Ihr Name"/>
            </div>

            <div class="form-group">
              <label>E-Mail</label>
              <input type="email" placeholder="ihre@email.de"/>
            </div>

          </div>

          <div class="form-group">
            <label>Telefon</label>
            <input type="text" placeholder="+49 ..."/>
          </div>

          <div class="form-group">
            <label>Nachricht</label>
            <textarea
                rows="6"
                placeholder="Was können wir für Sie tun?"
            />
          </div>

          <button type="submit" class="submit-btn">

            <Send/>

            Anfrage senden

          </button>

        </form>

      </div>

    </div>

  </section>

</template>

<style scoped>
</style>